import { useEffect, useState } from 'react';

export type Route = { name: 'home' } | { name: 'board'; id: string } | { name: 'join'; token: string } | { name: 'notfound' };

export function parseRoute(pathname: string): Route {
  const p = pathname.replace(/\/+$/, '') || '/';
  if (p === '/') return { name: 'home' };
  let m = /^\/board\/([^/]+)$/.exec(p);
  if (m) return { name: 'board', id: decodeURIComponent(m[1]) };
  m = /^\/join\/([^/]+)$/.exec(p);
  if (m) return { name: 'join', token: decodeURIComponent(m[1]) };
  return { name: 'notfound' };
}

const EVT = 'xb:navigate';

export function navigate(path: string, opts: { replace?: boolean } = {}): void {
  if (opts.replace) history.replaceState(null, '', path);
  else history.pushState(null, '', path);
  window.dispatchEvent(new Event(EVT));
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parseRoute(location.pathname));
  useEffect(() => {
    const on = () => setRoute(parseRoute(location.pathname));
    window.addEventListener('popstate', on);
    window.addEventListener(EVT, on);
    return () => {
      window.removeEventListener('popstate', on);
      window.removeEventListener(EVT, on);
    };
  }, []);
  return route;
}
